export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },

  settings: {
    settings: "/settings",
    settings_details: "/settings/details",
  },

  legal_information: {
    legal_information: "/legal_information",

  },
  clients: {
    clients: "/clients",
  },
  about_us: {
    about_us: "/about_us",
  },
  blog: {
    blog: "/blog",
  },
  case_study: {
    case_study: "/case_study",
  },
  exclusive: {
    exclusive: "/exlusive",
  },

  slideshow: {
    slideshow: "/slideshow",
    slideshow_details: "/slideshow/details",
  },

  what_we_do: {
    what_we_do: "/what_we_do",
  },
  intro_call: {
    intro_call: "/intro_call",
  },

  contact_info: {
    contact_info: "/contact_info",
  },
  profile: {
    profile: "/profile",
  },

  services: {
    services: "/services",
  },

  services_info: {
    services_info: "/services_info/:id",
  },
  projects: {
    projects: "/projects",
  },

  testimonials: {
    testimonials: "/testimonials",
  },

  admins_logs: {
    admins_logs: "/admins_logs",
  },



};
